// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VideoCameraOutlinedSvg from "@fishx/icons-svg/es/asn/VideoCameraOutlined";
import FishxIcon from '../components/FishxIcon';

var VideoCameraOutlined = function VideoCameraOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraOutlinedSvg
  }));
};

VideoCameraOutlined.displayName = 'VideoCameraOutlined';
export default React.forwardRef(VideoCameraOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VideoCameraOutlined.js
// module id = 4371
// module chunks = 0